import { useEffect, useState } from 'react';
import { GridToolbarContainer } from '@mui/x-data-grid-premium';
import { Box, Paper } from '@mui/material';

import { dataGridPremiumColumns } from '../../../utils/helper';
import { DataGridIdentifiers, AddButtonUi, DatagridPremiumUi } from '../../Interface';
import ProductionReceiptDialog from './ProductionReceiptDialog';

const EditToolbar = (props) => {
  const { disabled, setDialogOpen } = props;

  const handleClick = async () => {
    setDialogOpen(true);
  };

  return (
    <GridToolbarContainer>
      <AddButtonUi disabled={disabled} onClick={handleClick} />
    </GridToolbarContainer>
  );
};

const ProductionReceipt = (props) => {
  const { selectedValues, disabled } = props;
  const [reports, setReports] = useState([]);

  const [dialogOpen, setDialogOpen] = useState(false);

  const columns = dataGridPremiumColumns([
    {
      field: 'docNumber',
      headerName: 'Biz. szám',
      type: 'string',
      valueGetter: (_data, row) => row.doc.docNum,
    },
    {
      field: 'itemCode',
      headerName: 'Cikkszám',
      type: 'string',
    },
    {
      field: 'itemName',
      headerName: 'Cikknév',
      type: 'string',
    },
    {
      field: 'qty',
      headerName: 'Mennyiség',
      type: 'string',
      filterable: false,
    },
    {
      field: 'quantityUnitCode',
      headerName: 'Me.',
      type: 'string',
      filterable: false,
      sortable: false,
    },
  ]);

  useEffect(() => {
    setReports(selectedValues?.receipts ?? []);
  }, [selectedValues]);

  return (
    <>
      <Box sx={{ overflowX: 'auto' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Paper elevation={2} sx={{ overflow: 'hidden', boxShadow: 3, borderRadius: 2, width: '100%' }}>
            <DatagridPremiumUi
              datagridIdentifier={DataGridIdentifiers.ProductionReceipt}
              height={480}
              columns={columns}
              rows={reports}
              slots={{
                toolbar: EditToolbar,
              }}
              slotProps={{
                toolbar: {
                  disabled,
                  setDialogOpen,
                },
              }}
              headerFilters={false}
              getRowHeight={() => 'auto'}
              getRowId={(row) => `${row.docId}_${row.lineNum}`}
            />
          </Paper>
        </Box>
      </Box>
      <ProductionReceiptDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSave={(data) => {
          setReports((prev) => [...prev, data]);
          setDialogOpen(false);
        }}
        {...props}
      />
    </>
  );
};

export default ProductionReceipt;
